const country = (iso2, name, iso3) => ({
  iso2,
  iso3,
  name
});

export const COUNTRY_MAP = {
  AR: country('AR', 'Argentina', 'ARG'),
  AT: country('AT', 'Austria', 'AUT'),
  AU: country('AU', 'Australia', 'AUS'),
  BE: country('BE', 'Belgium', 'BEL'),
  BN: country('BN', 'Brunei Darussalam', 'BRN'),
  CA: country('CA', 'Canada', 'CAN'),
  CH: country('CH', 'Switzerland', 'CHE'),
  CL: country('CL', 'Chile', 'CHL'),
  CO: country('CO', 'Colombia', 'COL'),
  CZ: country('CZ', 'Czechia', 'CZE'),
  DE: country('DE', 'Germany', 'DEU'),
  DK: country('DK', 'Denmark', 'DNK'),
  ES: country('ES', 'Spain', 'ESP'),
  FI: country('FI', 'Finland', 'FIN'),
  FR: country('FR', 'France', 'FRA'),
  GB: country('GB', 'United Kingdom', 'GBR'),
  HK: country('HK', 'Hong Kong', 'HKG'),
  HU: country('HU', 'Hungary', 'HUN'),
  ID: country('ID', 'Indonesia', 'IDN'),
  IE: country('IE', 'Ireland', 'IRL'),
  IL: country('IL', 'Israel', 'ISR'),
  IN: country('IN', 'India', 'IND'),
  IS: country('IS', 'Iceland', 'ISL'),
  IT: country('IT', 'Italy', 'ITA'),
  JP: country('JP', 'Japan', 'JPN'),
  LU: country('LU', 'Luxembourg', 'LUX'),
  MX: country('MX', 'Mexico', 'MEX'),
  MY: country('MY', 'Malaysia', 'MYS'),
  NC: country('NC', 'New Caledonia', 'NCL'),
  NL: country('NL', 'Netherlands', 'NLD'),
  NO: country('NO', 'Norway', 'NOR'),
  NZ: country('NZ', 'New Zealand', 'NZL'),
  PE: country('PE', 'Peru', 'PER'),
  PF: country('PF', 'French Polynesia', 'PYF'),
  PH: country('PH', 'Philippines', 'PHL'),
  PL: country('PL', 'Poland', 'POL'),
  PT: country('PT', 'Portugal', 'PRT'),
  RO: country('RO', 'Romania', 'ROU'),
  SE: country('SE', 'Sweden', 'SWE'),
  SG: country('SG', 'Singapore', 'SGP'),
  SK: country('SK', 'Slovakia', 'SVK'),
  TH: country('TH', 'Thailand', 'THA'),
  TR: country('TR', 'Türkiye', 'TUR'),
  US: country('US', 'United States', 'USA'),
  VN: country('VN', 'Viet Nam', 'VNM'),
  ZA: country('ZA', 'South Africa', 'ZAF')
};

export const SUPPORTED_COUNTRIES = Object.freeze(Object.keys(COUNTRY_MAP));
